import styled, { css, keyframes } from 'styled-components';

const blink = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

export const Button = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  background: none;
  border: none;
  transition: transform 0.2s ease;
  cursor: pointer;

  ${({ $copied }) =>
    $copied &&
    css`
      animation: ${blink} 0.5s ease;
    `}
`;
